import { Component } from "preact";
import classNames from "classnames";
import styles from "./Section.css";

export default class Section extends Component {

	render(props, state, ctx) {
		return (
			<section {...props} className={classNames(styles.Section)}>
				{
					props.children
				}
			</section>
		);
	}
}


// WEBPACK FOOTER //
// ./components/Section/Section.js